enum FeuilleSaisieCode {
	DOTATIONS_AUX_AMORTISSEMENT = 'DOTA',
	FONCTIONNEMENT = 'FONC',
	FONCTIONNEMENT_PRESENTATION_ALTERNATIVE = 'FONC_PRES_ALT',
	INVESTISSEMENT_PAR_CHAPITRE = 'INVC',
	INVESTISSEMENT_PAR_OPERATION = 'INVO',
	OPERATION_ORDRE_BUDGETAIRE = 'OPERO',
}

export default FeuilleSaisieCode;
